import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEExternalService } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { ESParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ESParameter';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { EnumDTPType } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MDAConstant } from '../../Base/MDAConstant';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType, EnumDataTypeMD } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointExternalServiceShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointExternalServiceShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_ExternalService.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEExternalService, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.parameters, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_EXTERNALSERVICE;
  }

  get externalService(): BEExternalService {
    return this.element() as BEExternalService;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加外部服务参数
      case 'shape:addESParameter':
        element = this.addESParameter();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof ESParameter) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addESParameter(): ESParameter {
    const parameter = MDRepository.createESParameter(this.externalService);
    MDExtendService.setElementListSequence(this.externalService.parameters, true);
    this.model().compartments[0].push(parameter);
    return parameter;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.externalService.parameters.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.externalService.parameters.splice(this.externalService.parameters.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(externalService: BEExternalService, isCollapse = false): ShapeModel {
    const model = new ShapeModel(externalService, isCollapse);
    model.addCompartment(externalService.parameters.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointExternalServiceShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEExternalService();
    newElement.copyFrom(this.externalService, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.externalServices.push(newElement);
    }

    this.externalService.parameters.forEach(item => {
      const parameter = new ESParameter();
      parameter.copyFrom(item, false);
      MDExtendService.setCreateInfo(parameter);
      parameter.externalService_ID = newElement.id;
      newElement.parameters.push(parameter);
      elements.push(parameter);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): ESParameter | null {
    let newElement: ESParameter | null = null;
    if (element instanceof ESParameter) {
      newElement = new ESParameter();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.externalService_ID = this.externalService.id;
      this.externalService.parameters.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 外部服务
   *    - 必须填写服务地址、服务名称和操作
   *    - 在分布式事务下，目前仅支持TCC协议
   * 2. 返回值
   *    - 必须选择返回值引用数据类型
   *    - 设置返回分页的时候，必须设置返回值是集合
   * 3. 参数
   *    - 必须选择引用数据类型
   *    - 不能存在同名参数
   * 4. 服务操作
   *    - 不能存在同名服务操作
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.externalService.designId;
    MDValidation.validateBaseElement(this.externalService, this.externalService.designId, true, errors);
    if (this.externalService.returnDataType === EnumDataType.Reference && !ValidateHelper.IsNotNullOrEmpty(this.externalService.returnReferenceType)) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `外部服务 [${this.externalService.displayName}] 必须选择返回值引用数据类型`));
    }
    if (this.externalService.returnIsPaged && !this.externalService.returnIsCollection) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `外部服务 [${this.externalService.displayName}] 设置返回分页的时候，必须设置返回值是集合`));
    }
    if (!ValidateHelper.IsNotNullOrEmpty(this.externalService.serviceUrl) || !ValidateHelper.IsNotNullOrEmpty(this.externalService.serviceName) || !ValidateHelper.IsNotNullOrEmpty(this.externalService.action)) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `外部服务 [${this.externalService.displayName}] 必须填写服务地址、服务名称和操作`));
    }
    if (this.externalService.enableDistributeTransaction && this.externalService.dTPType !== EnumDTPType.TCC) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `外部服务 [${this.externalService.displayName}] 在分布式事务下，目前仅支持TCC协议`));
    }
    this.externalService.parameters.forEach(element => {
      MDValidation.validateBaseElement(element, containerDesignId, false, errors);
      if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `外部服务 [${this.externalService.displayName}] 的参数 [${element.displayName}] 必须选择引用数据类型`));
      }
      if (this.externalService.parameters.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `外部服务 [${this.externalService.displayName}] 不能存在同名参数 [${element.name}]`));
      }
    });
    this.externalService.serviceActions.forEach(element => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if (this.externalService.serviceActions.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `外部服务 [${this.externalService.displayName}] 不能存在同名服务操作 [${element.name}]`));
      }
    });
    return errors;
  }
}
